<template>
  <div>
    <v-layout align-center style="height:100vh">
      <v-flex xs4 lg4 xl4 hidden-md-and-down class="session-left">
        <v-spacer>&nbsp;</v-spacer>
      </v-flex>
      <v-flex xs12 sm12 md12 lg8 xl8 class="text-xs-center">
        <v-container>
          <v-layout row wrap>
            <v-flex lg4>
              <v-spacer>&nbsp;</v-spacer>
            </v-flex>
            <v-flex lg4>
              <div class="text-xs-center text-lg-center">
                <img :src="appLogo" class="img-responsive mb-3" width="200" height="78">
                <br>
                <span style="font-size:21px;font-weight:410">Oficina virtual para los APS</span>
                <p
                  class="mt-4"
                  style="font-size:12px"
                >Introduzca su usuario y contraseña para iniciar</p>
                <v-form class="mb-4" v-model="formLoginValid">
                  <v-text-field
                    browser-autocomplete="off"
                    label="E-mail"
                    placeholder="Escriba su email"
                    @keyup.enter="loginUser()"
                    v-model="username"
                    :rules="[rules.required,rules.email]"
                  ></v-text-field>
                  <v-text-field
                    browser-autocomplete="off"
                    label="Contraseña"
                    placeholder="Escriba su contraseña"
                    v-model="password"
                    type="password"
                    hide-details
                    :rules="[rules.required]"
                    @keyup.enter="loginUser()"
                  ></v-text-field>
                  <br>
                  <a
                    href="#"
                    class="mb-1"
                    to
                    style="font-size:12px"
                    @click="generateTokenPassword()"
                  >Olvidé mi contraseña</a>
                  <div>
                    <v-btn
                      :loading="loading"
                      :disabled="loading||!formLoginValid"
                      color="primary"
                      large
                      @click="loginUser()"
                    >INICIAR SESIÓN</v-btn>
                  </div>
                </v-form>
              </div>
            </v-flex>
            <v-flex lg4>
              <v-spacer>&nbsp;</v-spacer>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AppConfig from "@/config/AppConfig";
/* import SliderLogin from "./SessionSlider"; */
import { bodyScript } from "@/common/helpers/helpers";
import Vue from "vue";

export default {
    computed: {
    ...mapGetters([      
      "userProfile",
      "userScopes"
    ])
  },
  data() {
    return {
      username: "",
      password: "",
      formLoginValid: false,
      appLogo: AppConfig.appLogo2,
      loading: false,
      rules: 
      {
        required: value => !!value || "Campo Requerido",
        email: value => 
        {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Dirección email invalida";
        }
      }
    };
  },
  mounted() {
    this.username= "";
    this.password= ""
  },
  methods: {
    generateTokenPassword() {
      this.$store.dispatch("generateTokenPassword").then(res => {
        this.$router.push("/session/forgot-password");
      });
    },
    validaUsuarioActivo(){
      var respu = false;
      if(this.userProfile.Estado == "I") 
      {
        respu = true
      } 
      return respu;
    },
    loginUser() {
      
      if (this.formLoginValid) {
        this.loading = true;        
        this.$store.dispatch("login", {
            username: this.username.trim(),
            password: this.password
          })
          .then(res => {
            
            if (res.data.code == 200) {
              bodyScript(AppConfig.baseUrlChatbootSofia);
              setTimeout(() => {    
                             
              if(this.userScopes.includes('aps_admin')){
                !this.validaUsuarioActivo() ? this.$router.push("/pushNotifications") : this.$root.$emit(
                "showSnackBar",
                "Usuario inactivo, por favor comuníquese con su ejecutivo comercial",
                "error"
              ); 

              }else if(this.userScopes.includes('aps_promotor')){
                !this.validaUsuarioActivo() ?  this.$router.push("/quoting") : this.$root.$emit(
                "showSnackBar",
                "Usuario inactivo, por favor comuníquese con su ejecutivo comercial",
                "error"
              );
               
              }else{
                !this.validaUsuarioActivo() ?  this.$router.push("/") : this.$root.$emit(
                "showSnackBar",
                "Usuario inactivo, por favor comuníquese con su ejecutivo comercial",
                "error"
              );
                
              }
              let sofi_data = {
                  code : 200,
                  msg : "User profile",
                  data: {
                    appId: "5c33d14ecc761c4d05397c57",
                    profile: this.userProfile,
                    scope: ["aps_user", "user", "aps_admin", "aps_broker"]
                  }
              };
                try{
                  sofi.init(JSON.stringify(sofi_data));
                  // eslint-disable-next-line no-empty
                }catch(err){
                }
              }, 500);
            } else if (res.data.code == 404 || res.data.code == 401) {
              this.$root.$emit(
                "showSnackBar",
                "Usuario y/o contraseña incorrecto",
                "error"
              );
            }
            else if (res.data.code == 403 ) {
              this.$root.$emit(
                "showSnackBar",
                "Su Usuario ha sido Bloqueado por favor contáctese con el Administrador.",
                "error"
              );
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>
<style scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.bglogin {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(https://lh3.googleusercontent.com/-l6PPVmoXaNY/XEJBEfYtdpI/AAAAAAAAAhY/BS09657-Iqw16MlezouU1VEr8HIr8riAwCL0BGAYYCw/h672/2019-01-18.jpg);
  background-size: 100% 100%;
}
</style>